import { cx } from '@platform/core/lib/cx';
import { Icon } from '../Icon';
import type { IPickerTriggerProps } from './IPickerTriggerProps';

/**
 * Поле пікера (прототип v4): 34px (sm/inline/key — 30px), радіус 8, крапка 8px + значення (порожнє — muted) + шеврон 14px,
 * що повертається при відкритті; відкрите — рамка акценту й кільце 3px. key — мітка «ПОЛЕ:» 11px 600 ВЕЛИКИМИ й значення 600;
 * inline — прозоре до наведення. Лише читання — сіре тло, рамка --line, без шеврона (data-ro прототипу).
 * ARIA — комбобокс лише з вибором (role=combobox, aria-haspopup=listbox, aria-expanded, aria-controls, aria-activedescendant).
 */
export function PickerTrigger(p: IPickerTriggerProps) {
  const { current, size } = p;
  return (
    <button ref={p.buttonRef} id={p.id} type="button" role="combobox" className={cx('pk', `pk--${size}`, p.open && 'is-open', p.readOnly && 'is-ro', p.className)}
      aria-haspopup="listbox" aria-expanded={p.open} aria-controls={p.open ? p.listId : undefined} aria-label={p.label}
      aria-activedescendant={p.open ? p.activeId : undefined} aria-invalid={p.invalid || undefined} aria-readonly={p.readOnly || undefined}
      disabled={p.disabled} title={p.title ?? (current ? current.label : undefined)} autoFocus={p.autoFocus}
      onClick={() => !p.readOnly && p.onToggle()} onKeyDown={(e) => !p.readOnly && p.onKeyDown(e)} onBlur={p.onBlur}
      onKeyUp={(e) => { if (e.key === ' ') e.preventDefault(); }}>
      {p.prefix && <span className="pk__prefix">{p.prefix}</span>}
      {p.leading}
      {current?.dot && <span className="pk__dot" style={{ background: current.dot }} />}
      <span className={cx('pk__text', !current && 'is-empty')}>{current ? current.label : p.placeholder}</span>
      {!p.readOnly && <Icon name="chevron-down" size={size === 'key' ? 13 : 14} strokeWidth={2} className="pk__chev" />}
    </button>
  );
}
